import { memo, useId } from 'react';
import { cosmeticBySlug } from '@kidshome/hero-content';
import { heroPluginFor } from '@/entities/hero';

/**
 * A decorative PREVIEW of a cosmetic item for its catalog card — the SAME per-item art the hero wears,
 * cropped to its place region, so the card always matches what lands on the figure. Fully hero-AGNOSTIC
 * (ADR-0100): it resolves the item's owning hero from the catalog ({@link cosmeticBySlug}) and delegates to
 * that hero's render plugin ({@link heroPluginFor} → `renderItemIcon`), so the web never branches on a hero
 * id. An unknown slug resolves to the neutral plugin's tinted dot. Purely decorative (`aria-hidden`).
 */
export const CosmeticPreview = memo(function CosmeticPreview({
  category,
  itemId,
  className,
}: {
  category: string;
  itemId: string;
  className?: string;
}): React.ReactElement {
  const archetypeId = cosmeticBySlug(itemId)?.heroArchetype ?? null;
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  return heroPluginFor(archetypeId).renderItemIcon({
    slug: itemId,
    place: category,
    className,
    uid,
  });
});
